












































































































































import Vue from 'vue';
import { IfExpression, Expression, NoExpression, ChainExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';
import { getConfirmation } from '../../../app/Confirm';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_REMOVE_ELSEIF = Preferences.define({
  key: 'if_remove_elseif',
  label: 'Remove Else If from If expressions without confirmation',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default ExpressionBase<IfExpression>().extend({
  name: 'IfEditor',
  data: () => ({
    sorting: false,
    showingElse: false,
  }),
  computed: {
    showElse(): boolean {
      return this.showingElse || this.value.otherwise !== NoExpression.instance;
    },
    canShowElse(): boolean {
      return this.value.otherwise === NoExpression.instance && !this.showingElse;
    },
    canHideElse(): boolean {
      return this.value.otherwise === NoExpression.instance && this.showingElse;
    },
  },
  methods: {
    sortStart() {
      this.sorting = !this.sorting;
    },
    toggleElse() {
      this.showingElse = !this.showingElse;
    },
    updateCondition(index: number, condition?: Expression) {
      this.$set(this.value.cases[index], 0, condition || NoExpression.instance);
      this.update();
    },
    updateBody(index: number, body?: Expression) {
      this.$set(this.value.cases[index], 1, body || NoExpression.instance);
      this.update();
    },
    addGroup() {
      this.value.cases.push([NoExpression.instance, NoExpression.instance]);
      this.update();
    },
    updateElse(otherwise?: Expression) {
      this.value.otherwise = otherwise || NoExpression.instance;
      this.update();
    },
    isChain(expr: Expression) {
      return expr instanceof ChainExpression;
    },
    async removeGroup(index: number) {
      if (await getConfirmation({ pref: PREF_REMOVE_ELSEIF })) {
        this.value.cases.splice(index, 1);
        this.update();
      }
    },
  },
});
